import React, { useCallback, useEffect, useState } from "react";
import { DashCard } from "../UI/DashCard";
import { BtnOutlineV4 } from "../UI/button/BtnOutlineV4";
import {
  readReportTemplates,
  removeReportTemplate,
  REPORT_TEMPLATES_CHANGED_EVENT,
} from "../../utils/reportTemplatesStorage";

export function ProfileReportTemplatesPanel() {
  const [templates, setTemplates] = useState(() => readReportTemplates());

  const refresh = useCallback(() => {
    setTemplates(readReportTemplates());
  }, []);

  useEffect(() => {
    refresh();
    const onChanged = () => refresh();
    window.addEventListener(REPORT_TEMPLATES_CHANGED_EVENT, onChanged);
    return () =>
      window.removeEventListener(REPORT_TEMPLATES_CHANGED_EVENT, onChanged);
  }, [refresh]);

  return (
    <DashCard className="profile-report-templates-card" title="Мои шаблоны отчётов">
      {templates.length === 0 ? (
        <p className="profile-report-templates-empty">Шаблонов пока нет</p>
      ) : (
        <ul className="profile-alerts-list profile-report-templates-list">
          {templates.map((tpl) => (
            <li key={tpl.id} className="profile-alert-row">
              <span className="profile-alert-text" title={tpl.name}>
                {tpl.name}
              </span>
              <BtnOutlineV4
                text="Удалить"
                onClick={() => removeReportTemplate(tpl.id)}
              />
            </li>
          ))}
        </ul>
      )}
    </DashCard>
  );
}
